import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonLabel, IonInput, useIonAlert, IonButtons, IonButton, IonItemGroup, IonItemDivider, IonDatetimeButton, IonCheckbox, IonTextarea, IonModal, IonDatetime, IonSegment, IonSegmentButton, IonIcon, IonLoading, IonFooter, IonRow, IonCol, IonTabButton, IonInfiniteScroll, IonInfiniteScrollContent, useIonViewWillEnter, IonList, ScrollDetail, IonSpinner } from '@ionic/react';
import { useEffect, useRef, useState } from 'react';
import './SmsViewer.css';
import { useHistory, useParams } from 'react-router';
import { getClient, addClient, removeClient, getClientByPhone } from '../firebase/clients';
import { getMoreSmses, registerSmsSnapshotListener, saveAndSendSms } from '../firebase/sms';
import { getClientEvents } from '../firebase/events';
import dateFormat from 'dateformat';
import { callOutline, checkmarkCircleOutline, chevronBack, closeCircleOutline, ellipseSharp, helpCircle, helpCircleOutline, paperPlane, paperPlaneOutline } from 'ionicons/icons';
import { getCurrentUser } from '../firebase/firebase';
import { getUser } from '../firebase/users';
import { getUserNameByPhone } from './SmsPage';


const ClientEventsViewer: React.FC<{ clientId: string }> = (props) => {

  const [presentAlert] = useIonAlert();
  const [eventList, setEventList] = useState<any[]>([]);
  const params: any = useParams();
  const history = useHistory();
  const [isLoading, setLoading] = useState(false);
  const [busy, setBusy] = useState(false);



  useEffect(() => {
    if (props.clientId !== undefined) {
        getClientEvents(props.clientId, ((clientEventList: []) => {
          setEventList(clientEventList);
        }));
    }
  }, []);




  const content = useRef<HTMLIonContentElement>(null);


  var lp =1;
  return (
    <IonPage>
      <IonLoading message="Proszę czekać..." duration={0} isOpen={busy} />

      <IonContent ref={content}>

        <div style={{ width: "100%", maxWidth: "650px", textAlign: "center" }} hidden={!isLoading}><IonSpinner /></div>

        <IonList>

            {eventList.map((item: any) => {
              return <div>
                <IonItem key={item.id} >
                  <IonLabel>
                    <div style={{ display:'flex'}}>
                      <div style={{minWidth:20,  textAlign:'right', marginRight:5}}>{lp++}.</div>
                      <div style={{minWidth:140, textAlign:'center', marginRight:5}}>{dateFormat(item.start.toDate(), "yyyy-mm-dd HH:MM")}</div>
                      <div style={{minWidth:30,  textAlign:'center', marginRight:5}}>{item.user.initials}</div>
                      <div style={{ marginRight:10}}>{item.status}</div>
                      <div style={{ marginRight:10}}>{item.comments}</div>
                    </div>
                    
                  </IonLabel>
                </IonItem>
              </div>
            })}
        </IonList>

      </IonContent>


    </IonPage >
  );
};

export default ClientEventsViewer;
